<template>
  <el-drawer title="人员位置信息" :visible.sync="drawer" size='600px' :direction="direction">
    <div class="content">
      <baidu-map id="homeMap" class="baidu-map" :center="center" :zoom="zoom" :mapClick="false" :scroll-wheel-zoom='true' :inertial-dragging='true' @ready="handleMap">
        <bm-overlay pane="labelPane" :class="{sample: true,active}" @draw="draw" @mouseover.native="active = true" @mouseleave.native="active = false">
          <div>当前人员：{{mainExecutorName}}</div>
        </bm-overlay>
        <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
      </baidu-map>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "detail",
  data () {
    return {
      active: false,
      drawer: false,
      direction: "btt",
      center: { lng: 0, lat: 0 },
      zoom: 3,
      mapObj: {},
      mainExecutorName: ''
    };
  },
  methods: {
    draw ({ el, BMap, map }) {
      const pixel = map.pointToOverlayPixel(new BMap.Point(this.center.lng, this.center.lat))
      el.style.left = pixel.x + 18 + 'px'
      el.style.top = pixel.y - 40 + 'px'
    },
    init (row) {
      console.log(row)
      this.drawer = true;
      this.order = Object.assign({}, row);
      const userId = this.order.mainExecutor
      this.mainExecutorName = this.order.mainExecutorName
      this.$api.electricOperations.getUserLocation(userId).then((res) => {
        if (res.success) {
          const location = res.data.pop() || {}
          console.log(location)
          if (Object.keys(location).length === 0) {
            return
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.center = {
                lng: location.longitude,
                lat: location.latitude
              }
            }, 100)
          })
        }
      })
    },
    handleMap ({ BMap, map }) {
      this.center = Object.assign({}, { lng: 113.45189858576036, lat: 23.167427313781808 })
      this.zoom = 17
      setTimeout(() => {
        map.centerAndZoom(new BMap.Point(this.center.lng, this.center.lat), this.zoom)
      }, 800)
    }
  },
};
</script>

<style lang="scss" scoped>
.sample {
  height: 20px;
  line-height: 20px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  box-shadow: 0 0 5px #000;
  color: #fff;
  text-align: center;
  padding: 10px;
  position: absolute;
}
.sample.active {
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
}
.content {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.baidu-map {
  width: 100%;
  height: 100%;
}
</style>
